<template>
  <div id="full-library" ref="whole_page">
    <div class="vx-row mx-auto">
      <div class="vx-col xl:w-1/5 lg:w-1/5 md:w-full sm:w-full xs:w-full mb-4">
        <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color float-left" style="width: 277px">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_bg-color__blend bg-color">
                <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
              type="filled"
              color="">
              All Content
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
      <div class="vx-col xl:w-2/5 lg:w-2/5 md:w-full sm:w-full xs:w-full mb-4">
        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col xl:w-3/4 lg:w-3/4 md:w-full sm:w-full xs:w-full mb-4">
            <vx-card class="card__no-padding">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text school-primary_gradient">
                    <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <v-select
                  id="categorydropdown"
                  ref="genreDropdown"
                  class="w-full style-chooser-light"
                  placeholder="Search / Select a Category"
                  :options="availableGenresList"
                  v-model="genreDropdown"
                  style="height: 50px;"
                  @search:blur="executeSearch"
                  @input="clearGenre"
                />
              </vx-input-group>
            </vx-card>
          </div>
        </div>
      </div>
      <div class="vx-col xl:w-1/5 lg:w-1/5 md:w-full sm:w-full xs:w-full mb-4">
        <vx-card id="search-input" class="card__no-padding" style="border-radius: 30px !important;background-color: #ffffff;">
          <vx-input-group>
            <vs-input class="w-full full-library-search_input" @keyup.enter="executeSearch" onClick="this.select();" placeholder="Search..." v-model="query" />

            <template slot="append" class="append-slot-border">
              <div @click="executeSearch" class="append-text school-primary_gradient input-search_button" style="border-radius: 30px !important;">
                <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>
          </vx-input-group>
        </vx-card>
      </div>
      <div class="vx-col xl:w-1/5 lg:w-1/5 md:w-full sm:w-full xs:w-full mb-4">
        <vx-card id="search-input" class="card__no-padding" style="border-radius: 30px !important;background-color: #11193f;">
          <vx-input-group class="full-library_more-options">
            <div class="container text-left">
              <h4>More Options</h4>
            </div>

            <template slot="append" class="append-slot-border">
              <div @click="moreOptionsPopupActive = true" class="append-text school-primary_gradient input-search_button" style="border-radius: 30px !important;">
                <span><feather-icon class="pt-1" icon="SlidersIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div v-if="libraryContent.length > 0">
          <div class="vx-row" v-for="(category, index) in availableGenres" :key="index">
            <div class="vx-col w-full">
              <div v-if="libraryContent.filter(function(item) {return item.genreId == category.id}).length > 0" class="vx-row mb-3">
                <div class="vx-col w-full">
                  <h3 class="float-left">{{ category.name }}</h3>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="swiper-container mb-5">
                    <div class="swiper-inner">
                      <swiper :options="swiperOption">
                        <swiper-slide v-for="(resource, index) in libraryContent.filter(function(item) { return item.genreId == category.id })" :key="index">
                          <div class="vx-row">
                            <div class="vx-col w-full" style="align-self: center;">
                              <div class="vx-row">
                                <div class="vx-col w-full">
                                  <div class="img-container">
                                    <div v-if="resource.libraryResourceTypeId == 1">
                                      <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-book-open"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
                                    </div>
                                    <div v-if="resource.libraryResourceTypeId == 2">
                                      <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                                    </div>
                                    <div v-if="resource.libraryResourceTypeId == 3">
                                      <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-music"><path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle></svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-row" style="height: 50px">
                                <div class="vx-col w-full">
                                  <h5 class="text__school-font-color"><strong>{{ resource.title }}</strong></h5>
                                </div>
                              </div>
                              <div class="vx-row">
                                <div class="vx-col w-full">
                                  <div class="img-container">
                                    <img height="180px" class="reflection_bottom resource-thumb_img" @click="selectResource(resource, resource.libraryResourceTypeId)" :src="resource.coverPageThumbnailUrl"/>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-row mt-5" style="height: 60px">
                                <div class="vx-col w-full" style="padding: 0">
                                  <h5 class="font-white" style="background-color: rgba(115,103,240,1)"><strong>{{ resource.author ? resource.author : resource.producer }}</strong></h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                      </swiper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <h3>No content to show</h3>
        </div>
      </div>
    </div>

    <div>
      <vs-popup title="Information" id="resource-popup" :active.sync="resourcePopupActive">
        <div class="vx-row">
          <div class="vx-col sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3">
            <img :src="selectedResource.coverPageUrl" class="reflection_bottom" style="width: 100%;border-radius: 15px;"/>
          </div>
          <div class="vx-col sm:w-full md:w-1/2 lg:w-2/3 xl:w-2/3">
          <div class="vx-row">
              <div class="vx-col w-full">
                <div v-if="selectedResource.libraryResourceTypeId == 1">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-book-open"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
                </div>
                <div v-if="selectedResource.libraryResourceTypeId == 2">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                </div>
                <div v-if="selectedResource.libraryResourceTypeId == 3">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-music"><path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle></svg>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <h3>{{ selectedResource.genreName }}</h3>
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <h1 class="text__school-font-color"><strong>{{ selectedResource.title }}</strong></h1>
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <h5 class="text-white"><strong>{{ selectedResource.producer || selectedResource.author }}</strong></h5>
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <p class="text-white" style="text-align: justify;">{{ selectedResource.summary }}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedResource.libraryResourceTypeId == 1 || selectedResource.libraryResourceTypeId == 2" class="vx-row">
          <vs-spacer />
          <div class="vx-col">
            <vs-button
              ref="search"
              class="custom-button_library mt-2 vs-con-loading__container school-primary_gradient glow-effect_tertiary"
              @click="viewResource">
              <img style="float:left; margin-left:-7px; margin-right:5px; margin-top:-2px; height:25px" src="https://lateralscaffolding.blob.core.windows.net/resources/icon-view-custom.png"/>
              <strong>View</strong>
            </vs-button>
          </div>
        </div>
        <div v-else class="vx-row">
          <div class="vx-col w-full">
            <div id="podcast-container" ref="podcastViewer" class="xs:w-full sm:w-full md:w-1/2 lg:w-2/3 xl:w-2/3 float-right vs-con-loading__container">
              <video id="podcastPlayer" class="media-video-player card-video" controls />
            </div>
          </div>
        </div>
      </vs-popup>

      <vs-popup id="more-options-popup" title="More Options" :active.sync="moreOptionsPopupActive">
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vx-card class="card__no-padding" style="background-color: rgba(var(--vs-primary),1);border-radius: 3rem !important;">
              <div class="vx-row">
                <div class="vx-col w-1/3 pr-0">
                  <div class="h-full">
                    <p style="font-size: 20pt;letter-spacing: 1pt;font-weight: 600;padding-top: 4px;color: white;text-align-last: center;" class="pl-6">Show</p>
                  </div>
                </div>
                <div class="vx-col w-2/3 pl-0">
                  <v-select
                    id="resourceTypesDropdown"
                    ref="resourceTypesDropdown"
                    class="w-full style-chooser-light"
                    placeholder="Select a Type"
                    :options="typesList"
                    v-model="resourceTypesDropdown"
                    style="height: 50px;"
                  />
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vx-card style="background-color: #11193f;border-radius: 3rem !important;">
              <div class="vx-row">
                <div class="vx-col w-2/5 pr-0">
                  <div class="h-full" style="height: 31px !important;">
                    <p style="font-size: 12pt;letter-spacing: 1pt;font-weight: 600;color: white;text-align-last: center;padding-top: 3px;" class="pl-6">Only my Grade</p>
                  </div>
                </div>
                <div class="vx-col w-1/5 pr-0 pl-0">
                  <div class="h-full" style="height: 31px !important;">
                    <vs-switch color="success" class="w-full h-full" v-model="gradeSwitch" />
                  </div>
                </div>
                <div class="vx-col w-2/5 pl-0">
                  <div class="h-full" style="height: 31px !important;">
                    <p style="font-size: 12pt;letter-spacing: 1pt;font-weight: 600;color: white;text-align-last: center;padding-top: 3px;" class="pl-6">All in Library</p>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <vx-card id="full-library-search-card" title="" class="school-primary_gradient--opaque glow-effect_dark">
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <h2 class="float-left">FULL LIBRARY</h2>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mb-3">
              <vx-card class="card__no-padding">
                <vx-input-group>
                  <template slot="prepend">
                    <div class="prepend-text school-primary_gradient">
                      <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <v-select
                    id="categorydropdown"
                    ref="genreDropdown"
                    class="w-full style-chooser-light"
                    placeholder="Search / Select a Category"
                    :options="availableGenresList"
                    v-model="genreDropdown"
                    style="height: 50px;"
                  />
                </vx-input-group>
              </vx-card>
            </div>
            <div class="vx-col w-full mb-3">
              <p class="font-white" style="font-size: 16pt;text-align-last: center;"><strong>OR</strong></p>
            </div>
            <div class="vx-col w-full">
              <vx-input-group class="full-search_input-group">
                <vs-input v-model="query" class="w-full full-search-input" placeholder="Search Author, Title, Summary, Tags" />
              </vx-input-group>
            </div>
          </div>
        </vx-card>

        <div class="vx-row mt-3">
          <div class="vx-col w-full text-center">
            <vs-button
              style=""
              ref="search"
              class="custom-button_library mt-2 vs-con-loading__container school-primary_gradient glow-effect_tertiary"
              @click="executeSearch">
              <img style="float:left; margin-left:-7px; margin-right:5px; margin-top:-2px; height:25px" src="https://lateralscaffolding.blob.core.windows.net/resources/icon-search-custom.png"/>
              <strong>Search</strong>
            </vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
export default {
  components: {
    vSelect,
    swiper,
    swiperSlide,
    Plyr
  },
  data() {
    return {
      availableGenres: [],
      availableGenresList: [],
      libraryContent: [],
      tempLibraryContent: [],
      genreDropdown: 0,
      genres: [],
      genre: 0,
      query:"",
      swiperOption: {
        // centeredSlides: true,
        autoplay: {
          enabled: false,
          delay: 5000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerView: 7,
        spaceBetween: 5,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        breakpoints: {
          1366: {
            slidesPerView: 5,
            spaceBetween: 25
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        }
      },
      selectedResource: {},
      resourcePopupActive: false,
      podcastPlayer: null,
      fileExt: "",
      source: [],
      moreOptionsPopupActive: false,
      typesList: [
        {
          label: "Books Only",
          value: 1
        },
        {
          label: "Videos Only",
          value: 2
        },
        {
          label: "Podcasts Only",
          value: 3
        }
      ],
      resourceTypesDropdown: 0,
      gradeSwitch: false,
      type: null
    }
  },
  watch: {
    resourcePopupActive: function(val) {
      if (!val) {
        this.destroyPlayer();
      }
    }
  },
  methods: {
    getContent() {
      var self = this;
      self.showLoadingOnElement("whole_page", 1, "material");
      var onSuccess = response => {
        self.libraryContent = response.data;

        self.libraryContent.forEach(function(item) {
          item.fullString = item.title + item.summary + item.genreName + (item.isbn ? item.isbn : '') + (item.author ? item.author : '') + (item.producer ? item.producer : '');
        });

        self.tempLibraryContent = self.libraryContent;

        var tempGenres = self.libraryContent.map(function(item) { return { id: item.genreId, name: item.genreName } });
        tempGenres.forEach(genre => {
          if (self.availableGenres.filter(function(item) {
            return genre.id == item.id
          }).length == 0 && genre.id != null)
            self.availableGenres.push(genre);
        });
        self.availableGenresList = self.availableGenres.map((item) => { return { label: item.name, value: item.id } }).sort(function (a, b) { return a.label > b.label ? 1 : -1; });

        self.availableGenres = self.availableGenres.sort(function (a, b) { return a.name > b.name ? 1 : -1; });
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      if (!self.genre)
        self.genre = 0;

      if (!self.query)
        self.query = '';

      if (!self.type)
        self.type = 0;

      self.$ajaxGet(self, `LibraryResource/Search?genre=${self.genre}&query=${self.query}&type=${self.type}`, onSuccess, onFinally);
    },
    executeSearch() {
      var self = this;
      self.moreOptionsPopupActive = false;
      if (self.genreDropdown) {
        self.genre = self.genreDropdown.value;
      }
      else {
        self.genre = 0;
      }

      if (self.resourceTypesDropdown) {
        self.type = self.resourceTypesDropdown.value;
      }
      else {
        self.type = 0;
      }
      
      self.getContent();
    },
    clearGenre () {
      var self = this;

      if (!self.genreDropdown) {
        self.genre = "";
        self.getContent();
      }
    },
    selectResource(resource) {
      this.selectedResource = {};
      this.selectedResource = resource;
      this.resourcePopupActive = true;

      if (this.selectedResource.libraryResourceTypeId == 3) {
        this.playPodcast();
      }
    },
    playPodcast() {
      var self = this;
      var podcastUrl = self.selectedResource.url;

      self.podcastPlayer = new Plyr('#podcastPlayer', {
        autoplay: false
      });
      self.showLoadingOnElement("podcastViewer", 1, "material");

      var counter = 0;
      self.podcastPlayer.on('canplay', event => {
        counter++;
        if(counter == 2){
          self.$vs.loading.close(self.$refs.podcastViewer.$el);
        }
      });

      self.fileExt = podcastUrl.substr(podcastUrl.lastIndexOf(".") + 1);
      self.source = [{ type: "audio/" + self.fileExt, src: podcastUrl }];
      self.podcastPlayer.source = {
        type: 'audio',
        sources: self.source
      };
    },
    viewResource() {
      var self = this;
      self.resourcePopupActive = false;
      setTimeout(function() {
        if (self.selectedResource.libraryResourceTypeId == 1) {
          self.$router.push({ name: 'DocumentViewer', query: { id: self.selectedResource.id, url: self.selectedResource.url, orig: 'lib' } });
        }
        else if (self.selectedResource.libraryResourceTypeId == 2) {
          self.$router.push({ name: 'HLSVideoViewer', query: { id: self.selectedResource.id, url: self.selectedResource.url, orig: 'lib' } });
        }
      }, 200)
    },
    destroyPlayer() {
      var self = this;
      if(self.podcastPlayer)
        self.podcastPlayer.destroy();
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
  },
  mounted() {
    var self = this;
    self.$store.dispatch("updateTheme", "dark");
    self.genre = self.$route.query.c;
    self.query = self.$route.query.q;

    self.genreDropdown = 0;

    if (self.genre) {
      self.genreDropdown = self.availableGenresList.filter(function(item) { return item.value == self.genre });
    }

    self.getContent();
  }
};
</script>
<style lang="scss">
  #full-library {
    .swiper-wrapper {
      // height: 300px;
    }

    .swiper-inner {
      overflow: hidden;
      // padding: 15px;
      widows: 100% !important;
    }

    .swiper-container {
      width: 100% !important;
    }

    .swiper-slide {
      background-position: center;
      background-size: cover;
    }
  }

</style>
